module.exports = __webpack_public_path__ + "static/media/20ECE14.e84b37b1.jpg";